export function filenameFromObjectKey(objectKey: string): string {
  const fileName = objectKey.split("/").pop();
  return fileName || "kyc-document.jpg";
}

export function isPdfDocument(objectKeyOrUrl: string): boolean {
  const normalized = objectKeyOrUrl.split("?")[0].toLowerCase();
  return normalized.endsWith(".pdf");
}

export async function triggerBrowserDownload(
  presignedUrl: string,
  filename: string
): Promise<void> {
  const response = await fetch(presignedUrl);
  if (!response.ok) {
    throw new Error("Failed to download document");
  }

  const blob = await response.blob();
  const blobUrl = URL.createObjectURL(blob);
  const anchor = document.createElement("a");
  anchor.href = blobUrl;
  anchor.download = filename;
  document.body.appendChild(anchor);
  anchor.click();
  document.body.removeChild(anchor);
  URL.revokeObjectURL(blobUrl);
}
